import { render, staticRenderFns } from "./ExistingApplication.vue?vue&type=template&id=b51b5f66&scoped=true&"
import script from "./ExistingApplication.vue?vue&type=script&lang=js&"
export * from "./ExistingApplication.vue?vue&type=script&lang=js&"
import style0 from "./ExistingApplication.vue?vue&type=style&index=0&id=b51b5f66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51b5f66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VDivider,VIcon})
